import { Heading, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { Button } from 'reactstrap';

export interface IWarrantyHeaderProps {
    learnMoreButtonProps: any;
    showDetailButton?: boolean;
    resources: IWarrantyHeaderResourceData;
    className?: string;
    telemetryContent?: ITelemetryContent;
}

export interface IWarrantyHeaderResourceData {
    textTitle: string;
    textSubtitle: string;
    learnMoreButtonText?: string;
}

/**
 *
 * Warranty header component.
 * @extends {React.PureComponent<IWarrantyHeaderProps>}
 */
export class WarrantyHeader extends React.PureComponent<IWarrantyHeaderProps> {
    constructor(props: IWarrantyHeaderProps) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <div className={this.props.className}>
                <div className={`${this.props.className}-title`}>
                    <Heading
                        {...{
                            text: this.props.resources.textTitle ?? '',
                            className: `${this.props.className}-title__title`,
                            headingTag: 'h3'
                        }}
                    />
                </div>
                <div className={`${this.props.className}-subtitle`}>
                    <small className={`${this.props.className}-subtitle__subtitle`}>{this.props.resources.textSubtitle}</small>
                    {this.props.showDetailButton && this.props.learnMoreButtonProps && (
                        <Button {...this.props.learnMoreButtonProps}>{this.props.resources.learnMoreButtonText}</Button>
                    )}
                </div>
            </div>
        );
    }
}

export default WarrantyHeader;
